import CAApi from './_caApi';
import httpClient from '@/apis/base/httpclient';

class CAPaymentAPI extends CAApi {
  constructor() {
    super();
  }
  controllerName = 'CAPayments';

  /*
   * Hàm kiểm tra xem chứng từ đã được sinh hay chưa
   * @param {*} payload
   * @returns
   * NHANH3 3.11.2022
   */
  async CheckGenerateCAPaymentVoucher(payload) {
    let apiUrl = this.getAPIUrl();

    let request = {
      url: apiUrl + '/CheckGenerateVoucher',
      data: payload,
    };

    return await httpClient.getAsync(request);
  }

  /**
   * Hàm sinh chứng từ
   * @param {*} payload
   * @returns
   * NHANH3 3.11.2022
   */
  getDataVoucher(payload) {
    let request = {
      url: this.getAPIUrl() + '/DataVoucher',
      data: payload,
    };

    return httpClient.postAsync(request);
  }
}

export default new CAPaymentAPI();
